function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3300"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3291"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3288"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 31",
  cx: 27.802,
  cy: 27.802,
  r: 27.802,
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  transform: "translate(248.221 75.323)"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3289"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 32",
  cx: 20.844,
  cy: 20.844,
  r: 20.844,
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  transform: "translate(255.288 82.281)"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3290"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 33",
  cx: 6.158,
  cy: 6.158,
  r: 6.158,
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  transform: "translate(269.865 96.967)"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3295"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3292"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 34",
  cx: 27.802,
  cy: 27.802,
  r: 27.802,
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  transform: "translate(17.084 75.323)"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3293"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 35",
  cx: 20.844,
  cy: 20.844,
  r: 20.844,
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  transform: "translate(24.15 82.281)"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3294"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 36",
  cx: 6.158,
  cy: 6.158,
  r: 6.158,
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  transform: "translate(38.727 96.967)"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3296"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3011",
  d: "M5.955 53.473c-.048 1.34-.494 6.534 1.467 8.493s2.2.926 4.511-2.189c2.38-3.211 2.311-2.485 2.155-6.207-.041-.998-8.108-.809-8.133-.097z",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3012",
  d: "M339.691 90.232c-.024 1.261 3.569 1.083 6.352.892s5.011-5.737 5.9-7.912c.806-1.966.9-2.545.595-4.187s-2.688-1.356-5.805-1.356",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3297"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3013",
  d: "M2.409 81.575c-3.553 1.928.574 13.982 1.58 16.608s5.613 3.853 9.44 3.909.233-17.437.233-17.437-.219-.669-1.643-1.424",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3298"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3014",
  d: "M143.04 54.955a1.308 1.308 0 001.306 1.309h11.148a1.308 1.308 0 001.306-1.309v-2.613a1.308 1.308 0 00-1.306-1.309h-11.148a1.308 1.308 0 00-1.306 1.309z",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3299"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3015",
  d: "M208.315 53.858a1.308 1.308 0 001.307 1.309h11.147a1.308 1.308 0 001.306-1.309v-2.614a1.308 1.308 0 00-1.306-1.308h-11.147a1.308 1.308 0 00-1.307 1.308z",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3016",
  d: "M76.213 95.473c-3-13.184-13.13-30.887-30.752-31.266-17.445-.375-32.431 15.382-34.178 19.74-.235.585-3.686 2.856-7.38.775-2.307-1.3-1.779-14.355-1.375-20.221.493-7.109 2.172-14.4 4.784-16.95 4.4-4.3 61.406-11.83 71.721-13.048 2.9-.342 15.633-10.5 20.659-14.222s21.848-14.665 24.13-15.318c10.225-2.933 28.036-3.482 42.388-3.722 13.362-.223 59.405-1.144 61.474 2.152 3.79 6.04 5.98 19.987 6.643 33.139 13.082.162 45.993-.125 54.834-.112 10.332.016 59.6-.321 60.094.728 6.188 13.153-.134 35.275-3.252 41.634-2.137 4.359-5.156 11.308-5.6 11.36a260.886 260.886 0 01-32.326 1.839s1.876-28.266-26.534-28.944c-30.6-.732-36.388 29.6-36.862 32.434z",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3017",
  d: "M162.357 38.786c.156-.885-.054-6.708.077-14.242.093-5.353.523-13 .765-16.972 4.6-.139 19-.529 30.03-.347 12.971.213 21.019-.081 22.011.3 1.6.618 2.676 1.069 3.292 14.995.519 11.71.6 12.8-3.517 14.843-5.323 2.638-20.744 2.419-31.514 2.612-6.821.123-16.347.335-21.381.449.074-.591.152-1.14.237-1.638z",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3018",
  d: "M162.44 24.545c-.131 7.533.078 13.357-.077 14.242-.09.511-.17 1.074-.243 1.684-7.963.235-24.31.807-28.818.778-3.2-.021-48.212 1.521-48.213 1.052a7.771 7.771 0 011.354-4.883c.864-1.1 12.145-10.741 18.918-15.209s14.837-9.431 20.313-11.786c5.188-2.23 32.4-2.691 37.528-2.816-.244 3.984-.671 11.599-.762 16.938z",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}));

function SvgDriverSideGraphic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 309.636,
    height: 131.926,
    viewBox: "0 0 354 132"
  }, props), _ref);
}

export default SvgDriverSideGraphic;